export const Spinner = {
    OPEN: "spinner.open",
    CLOSE: "spinner.close",
};

export const SpinnerTypes = {
    INVENTORY: "inventory",
    MODIFY_CONFIRMATION: "modify_confirmation",
    CANCEL_CONFIRMATION: "cancel_confirmation",
};
